import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { WebUiConfig } from '@eql-ai/typescript-types';
import { startOfToday } from 'date-fns';
import { WebUiConfigActionTypes, WebUiConfigReducerAction } from './types';
import { ConfigRequestStatus, PhioStore } from '../types';
import { getWebUiConfigByClientId } from '../../services/webUiConfig';

const setRequestStatus = (status: ConfigRequestStatus) => {
    return {
        type: WebUiConfigActionTypes.SET_WEB_UI_CONFIG_REQUEST_STATUS,
        payload: status,
    };
};

export const setWebUiConfig = (
    config: WebUiConfig | null,
): WebUiConfigReducerAction => {
    if (config == null) {
        return {
            type: WebUiConfigActionTypes.SET_WEB_UI_CONFIG,
            payload: { config, lastRequestTime: null },
        };
    }

    return {
        type: WebUiConfigActionTypes.SET_WEB_UI_CONFIG,
        payload: { config, lastRequestTime: new Date().getTime() },
    };
};

export const setWebUiConfigByClientId = (
    clientId?: string | null,
): ThunkAction<void, PhioStore, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const { webUiConfigReducer } = getState();

        if (webUiConfigReducer.requestStatus === ConfigRequestStatus.LOADING) {
            return;
        }

        if (!clientId && webUiConfigReducer.config == null) {
            // client id and config are empty, do nothing
            return;
        }

        if (!clientId) {
            dispatch(setWebUiConfig(null));
            dispatch(setRequestStatus(ConfigRequestStatus.SUCCESS));
            return;
        }

        const startOfTodayTime = startOfToday().getTime();

        // eslint-disable-next-line camelcase
        if (
            clientId === webUiConfigReducer.config?.client_id &&
            webUiConfigReducer.lastRequestTime != null &&
            webUiConfigReducer.lastRequestTime < startOfTodayTime
        ) {
            // do nothing if provider matches
            return;
        }

        dispatch(setWebUiConfig(null));
        dispatch(setRequestStatus(ConfigRequestStatus.LOADING));

        const config = await getWebUiConfigByClientId(clientId);

        dispatch(setWebUiConfig(config));

        if (config) {
            dispatch(setRequestStatus(ConfigRequestStatus.SUCCESS));
        } else {
            dispatch(setRequestStatus(ConfigRequestStatus.NOT_FOUND));
        }
    };
};
